export default __webpack_public_path__ + "static/media/Wolf's Boots of the Khan.375a42e2.jpg";